import { Badge, Tooltip } from '@mantine/core';

// The amber "Please check" on a value the reader was not sure about, for the kit and the voice alike.
const ConfidenceBadge = ({ level }) =>
  level === 'low' ? (
    <Tooltip label="We were not sure about this one. Please compare it with your website." withArrow>
      <Badge size="xs" color="yellow" variant="light" tt="none">
        Please check
      </Badge>
    </Tooltip>
  ) : null;

export default ConfidenceBadge;
